import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import GradientButton from '../../../../components/buttons/GradientButton';
import LocationPicker from '../../../../locations/components/LocationPicker';
import useCompanyLocations from '../../../../locations/hooks/useCompanyLocations';
import { useManualBooking } from '../../../context/ManualBookingContext';
import { useAuth } from '../../../../context/AuthContext';

const LocationStep = ({ onNext, onBack }) => {
  const { companyData } = useAuth();
  const { bookingData, updateBookingData } = useManualBooking();
  const { activeLocations, defaultLocation, showLocationStep, loading } = useCompanyLocations({
    companyId: companyData?.id,
    companyData,
    activeOnly: true,
  });

  useEffect(() => {
    if (loading) return;

    if (!showLocationStep && defaultLocation) {
      updateBookingData({
        selectedLocation: defaultLocation,
        locationId: defaultLocation.id,
      });
      onNext?.();
    }
  }, [loading, showLocationStep, defaultLocation, updateBookingData, onNext]);

  const handleSelect = (location) => {
    updateBookingData({
      selectedLocation: location,
      locationId: location.id,
    });
  };

  const handleContinue = () => {
    if (!bookingData.selectedLocation?.id) return;
    onNext?.();
  };

  if (loading || !showLocationStep) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <Typography color="text.secondary">Loading locations…</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
        Choose location
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Select which business location this appointment is for.
      </Typography>

      <LocationPicker
        locations={activeLocations}
        selectedLocationId={bookingData.selectedLocation?.id || ''}
        onSelect={handleSelect}
        title=""
        subtitle=""
      />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <GradientButton
          variant="outlined"
          onClick={onBack}
          startIcon={<ArrowBackIcon />}
          sx={{ minWidth: 120 }}
        >
          Back
        </GradientButton>
        <GradientButton
          onClick={handleContinue}
          disabled={!bookingData.selectedLocation?.id}
          sx={{ minWidth: 160 }}
        >
          Continue
        </GradientButton>
      </Box>
    </Box>
  );
};

export default LocationStep;
